/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

interface CalculateProps {
  value: string | number | undefined
  decimalPlaces?: number
  defaultRem?: number
  maxLenth?: number
}

export const calculateFontsize = (data: CalculateProps) => {

  const { value, decimalPlaces = 2, defaultRem = 1, maxLenth = 10 } = data;

  if (!value) {
    return defaultRem
  }

  const [n = [], decimals = []] = String(value).split('.');
  const totalSpace = n.length + Math.min(decimals.length, decimalPlaces);
  return totalSpace > maxLenth ? defaultRem * maxLenth / totalSpace : defaultRem;
};

export const onlyLettersAndNumbers = (str: string) => {
  return /^[A-Za-z0-9]*$/.test(str);
};

export const isNumericString = (s: unknown): s is number => {
  if (typeof s !== 'string' || !s) {
    return false; // Empty string skips
  }
  return !Number.isNaN(Number(s));
};

export const truncate = (text: string, n: number, useWordBoundary: boolean = false): string => {
  if (text.length <= n) {
    return text;
  }
  const subString = text.slice(0, n);
  return (useWordBoundary ? subString.slice(0, subString.lastIndexOf(' ')) : subString) + '...';
};
